import LinkPost from "../../../../src/components/linkPost";
import ImgPost from "../../../../src/components/imgPost";
import Post from "../../../../contents/posts/52-github-branch-naming-convention /naming-convention.png";
import * as React from 'react';
export default {
  LinkPost,
  ImgPost,
  Post,
  React
};